import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";

import { P } from "../../atoms/Texts";
import { DarkFormField } from "../../atoms/Inputs";
import { PrimaryButton } from "../../atoms/Buttons";

import { toastWarning } from "../../../shared/helpers";

const PasswordUpdate = () => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    watch,
  } = useForm();

  const [passwordType] = useState("password");

  const onUpdatePassword = (data) => {
    toastWarning("Cannot perform this action on Demo mode");
  };

  const newPassword = watch("newPassword");

  return (
    <form onSubmit={handleSubmit(onUpdatePassword)}>
      <div className="w-full mx-auto mt-10 lg:mx-0 lg:w-1/2">
        <div>
          <DarkFormField
            type={passwordType}
            id="oldPassword"
            name="oldPassword"
            w="184px"
            placeholder="Enter old password"
            label="Old Password"
            className="w-full"
            {...register("oldPassword", {
              required: "Password is required.",
            })}
          />
          <ErrorMessage
            errors={errors}
            name="oldPassword"
            as={<P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />}
          >
            {({ messages }) =>
              messages &&
              Object.entries(messages).map(([type, message]) => (
                <P key={type}>{message}</P>
              ))
            }
          </ErrorMessage>
        </div>

        <div>
          <DarkFormField
            type={passwordType}
            id="newPassword"
            name="newPassword"
            w="384px"
            placeholder="Enter new password"
            label="New Password"
            className="w-full"
            {...register("newPassword", {
              required: "New Password is required.",
              minLength: {
                value: 8,
                message: "Password must be at least 8 characters",
              },
            })}
          />
          <ErrorMessage
            errors={errors}
            name="newPassword"
            as={<P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />}
          >
            {({ messages }) =>
              messages &&
              Object.entries(messages).map(([type, message]) => (
                <P key={type}>{message}</P>
              ))
            }
          </ErrorMessage>
        </div>

        <div>
          <DarkFormField
            type={passwordType}
            id="confirmPassword"
            name="confirmPassword"
            w="300px"
            placeholder="Enter confirmed new password"
            label="Confirm New Password"
            className="w-full"
            {...register("confirmPassword", {
              required: "New Password is required.",
              minLength: {
                value: 8,
                message: "Password must be at least 8 characters",
              },
              validate: (value) =>
                value === newPassword || "The passwords do not match",
            })}
          />
          <ErrorMessage
            errors={errors}
            name="confirmPassword"
            as={<P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />}
          >
            {({ messages }) =>
              messages &&
              Object.entries(messages).map(([type, message]) => (
                <P key={type}>{message}</P>
              ))
            }
          </ErrorMessage>
        </div>
      </div>

      <div className="mb-10 mx-auto">
        <PrimaryButton className="lg:w-1/2">Change Password</PrimaryButton>
      </div>
    </form>
  );
};

export default PasswordUpdate;
